<template>
  <div class="checkout_redesign--single-step-wrapper">
    <div class="checkout_redesign--single-step_header-wrapper">
      <h2 class="checkout_redesign--single-step_header">
        {{ `${stepData.title}${$i18nApi.t(stepData.translationString)}` }}
      </h2>
      <span v-if="!isFutureStep" class="checkout_redesign--single-step_icon"></span>
    </div>
    <div class="checkout_redesign--step">
      <div class="checkout_redesign--red-section"></div>
      <div
        class="checkout_redesign--blue-section checkout_redesign--section--bottom"
      >
        <button
          type="submit"
          class="checkout_redesign--text-uppercase"
          @click="goBack"
          :disabled="!isDirectlyPrevious"
        >
          {{ ctaText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: String,
      required: true,
    },
    stepData: {
      type: Object,
      required: true,
    },
    isFutureStep: {
      type: Boolean,
      required: false,
      default: false,
    },
    isDirectlyPrevious: {
      type: Boolean,
      required: false,
      default: false,
    },
    ctaText: {
        type: String,
        required: true,
    },
  },

  methods: {
    goBack() {
      this.$router.push({ name: `checkout-step-${this.step}` });      
    },
  },
};
</script>
